import React from "react";
import styled from "styled-components";
import PrimaryButton from "../../buttons/PrimaryButton";
import fontSize from "../../../theme/fonts/FontTheme";
import colors from "../../../theme/color/ColorTheme";

const Wrapper = styled.div`
  width: 100%;
`;
const Container = styled.div`
  width: inherit;
  color: black;
  font-size: 12px;
  line-height: 18px;
  padding-top: 24px;
  button {
    margin-top: 10px;
    width: inherit;
  }
`;

const Flex = styled.div`
  display: flex;
  justify-content: space-between;

  span {
    font-size: ${fontSize.xxs};
  }
`;
const Line = styled.div`
  border-bottom: solid 1px #b9b9b993;
  margin: 10px 0px;
`;

function CartBilling() {
  return (
    <Wrapper>
      <Container>
        <Flex>
          <span>Subtotal</span>
          <span>USD 0</span>
        </Flex>
        <Flex>
          <span>Shipping</span>
          <span>USD 0</span>
        </Flex>
        <Flex style={{ color: colors.primaryGray }}>
          <span>Included VAT</span>
          <span>13%</span>
        </Flex>
        <Line></Line>
        <Flex style={{ fontSize: "14px", color: colors.maroon }}>
          <div>TOTAL</div>
          <div>USD 0</div>
        </Flex>
        <PrimaryButton title={"Proceed To Checkout"} onClick={() => {}} />
      </Container>
    </Wrapper>
  );
}

export default CartBilling;
